<template>
  <div class="campaign-items">
    <campaign-item
      v-for="item in items"
      :key="item.idx"
      :author="item.author"
      :start="item.start_date"
      :end="item.end_date"
      :name="item.name"
      :status="item.status"
      :idx="item.idx"
      :is-admin="isAdmin"
      @modify="$emit('modify', item)"
      @delete="$emit('delete', item.idx)"
      @view="$emit('view', item)"
    />
  </div>
</template>

<script>
import CampaignItem from "./CampaignItem.vue";
export default {
  components: { CampaignItem },
  name: "CampaignItems",
  props: {
    items: Array,
    isAdmin: Boolean,
  },
};
</script>

<style lang="scss">
.campaign-items {
  display: flex;
  flex-wrap: wrap;
}
</style>
